import GalleryTab from './gallery-tab'

export default GalleryTab
